import React from 'react';


const DateFormat = ({date}) => (
  <>
    {date ?
      new Date(date).toLocaleString(
        'en-US',
        {
          dateStyle: 'medium',
          timeStyle: 'short'
        })
      : '---'
    }
  </>
);

export default DateFormat;
